import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { TwistLogoComponent } from '@twist/ui/components';
import { TwBtnComponent } from '@twist/ui-primitives';

/**
 * Shown in place of the app when the session cannot be recovered by logging in
 * again. Signing out clears every stored token and ends the identity-provider
 * session, which is the way out.
 */
@Component({
  selector: 'twist-session-error-page',
  standalone: true,
  imports: [TwistLogoComponent, TwBtnComponent],
  templateUrl: './session-error-page.component.html',
  styleUrl: './session-error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SessionErrorPageComponent {
  readonly signOut = output<void>();
}
